import users from 'modules/core/store/collections/users'

import type Employee from 'modules/employees/store/models/Employee'

type AuthorType = 'Access' | 'User' | null

interface Props {
  authorID: number | null
  authorType: AuthorType
  employee: Employee | null
}
export const isAuthorSameAsOwner = ({ authorID, authorType, employee }: Props): boolean => {
  if (employee === null) return false

  const user = users.find({ id: employee?.attributes.access_id })

  if (authorType == 'Access') return authorID === employee?.attributes.access_id
  if (authorType == 'User') return authorID === user?.id

  return false
}
